<template>
  <div class="sas">
    <div
      v-for="(item, index) in LocalSearchItems"
      :key="index"
      class="sas-row"
    >
      <div class="sas-pill">
        <div class="sas-pill-main">
          <div class="sas-pill-prefix">
            <feather-icon
              icon="FilterIcon"
              size="13"
              class="mr-25"
            />
          </div>

          <div class="sas-pill-select">
            <v-select
              v-model="item.selectedOption"
              class="sas-select"
              :options="SelectedItemSearchOptions"
              placeholder="Choose column"
              label="text"
              :searchable="true"
              :clearable="false"
              :disabled="dataLoad"
              @input="handleSearchItems"
            />
          </div>

          <span class="sas-pill-separator">contains</span>

          <div class="sas-pill-input">
            <b-form-input
              v-model="item.searchQuery"
              :disabled="dataLoad"
              class="sas-input"
              placeholder="Search …"
              @keydown.enter="handleSearchItems"
              @change="handleSearchItems"
            />
          </div>
        </div>

        <div class="sas-pill-actions">
          <button
            v-if="LocalSearchItems.length > 1"
            type="button"
            class="sas-icon-btn sas-icon-btn--remove"
            :disabled="dataLoad"
            @click="removeSearchAndSelectedItem(index)"
          >
            <feather-icon
              icon="MinusIcon"
              size="13"
            />
          </button>

          <button
            v-if="index === LocalSearchItems.length - 1"
            type="button"
            class="sas-icon-btn sas-icon-btn--add"
            :disabled="dataLoad"
            @click="addNewSearchAndSelectedItem"
          >
            <feather-icon
              icon="PlusIcon"
              size="13"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Active conditions chips -->
    <div
      v-if="LocalSearchItems.length && hasActiveChips"
      class="sas-chips"
    >
      <span class="sas-chips-label">Active conditions:</span>
      <span
        v-for="(item, idx) in activeChips"
        :key="`chip-${idx}`"
        class="sas-chip"
      >
        <span class="sas-chip-col">{{ item.selectedOption.text }}</span>
        <span class="sas-chip-sep">=</span>
        <span class="sas-chip-val">{{ item.searchQuery }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
  components: {
    VSelect,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    const defaultColumn = { value: 'request_code', text: 'Request Code' }
    return {
      LocalSearchItems: [
        { searchQuery: '', selectedOption: defaultColumn },
      ],
      SelectedItemSearchOptions: [
        // { value: 'all', text: 'All Data' },
        { value: 'request_code', text: 'Request Code' },
        { value: 'certificate_number', text: 'Certificate Number' },
        { value: 'category_request_no', text: 'Category Request Number' },
        { value: 'payment_status', text: 'Payment Status' },
        // { value: 'payment_method', text: 'Payment Method' },
        // { value: 'location', text: 'Location' },
        // { value: 'offer', text: 'Offer' },
        // { value: 'due_date', text: 'Due Date' },
        // { value: 'require_audit', text: 'Require Audit' },
        { value: 'facility_name', text: 'Facility Name' },
        { value: 'client_name', text: 'Requester' },
        // { value: 'set_parent', text: 'Set Parent' },
        // { value: 'first_reviewer', text: 'first reviewer' },
        // { value: 'first_reviewer_allocation_date', text: 'F.R Allocation Date' },
        // { value: 'second_reviewer', text: 'second reviewer' },
        // { value: 'second_reviewer_allocation_date', text: 'S.R Allocation Date' },
        // { value: 'application_reviewer', text: 'application reviewer' },
        // { value: 'application_reviewer_allocation_date', text: 'A.R Allocation Date' },
        // { value: 'last_status_update', text: 'Last Status Update' },
        // { value: 'jeem_request_type', text: 'Jeem Request Type' },
        // { value: 'certificate_price', text: 'Final Price' },
      ],
    }
  },
  computed: {
    hasActiveChips() {
      return this.LocalSearchItems.some(
        it => it.selectedOption && it.searchQuery,
      )
    },
    activeChips() {
      return this.LocalSearchItems.filter(
        it => it.selectedOption && it.searchQuery,
      )
    },
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        const controlledKeys = this.SelectedItemSearchOptions.map(opt => opt.value)
        const hasAnyControlled = controlledKeys.some(key => newQuery[key])

        // When reset button clears query, also clear local rows
        if (!hasAnyControlled) {
          const defaultColumn = { value: 'request_code', text: 'Request Code' }
          this.LocalSearchItems = [
            { searchQuery: '', selectedOption: defaultColumn },
          ]
        }
      },
      deep: true,
    },
  },
  mounted() {
    const { query } = this.$route
    const newItems = []

    Object.entries(query).forEach(([key, value]) => {
      const matchedOption = this.SelectedItemSearchOptions.find(opt => opt.value === key)
      if (matchedOption) {
        newItems.push({
          selectedOption: matchedOption,
          searchQuery: value,
        })
      }
    })

    // Only set if there are valid query items
    if (newItems.length) {
      this.LocalSearchItems = newItems
      this.handleSearchItems()
    }
  },
  methods: {
    handleSearchItems() {
      // Keys controlled by search widget
      const controlledKeys = this.SelectedItemSearchOptions.map(opt => opt.value)

      // Extract current query and remove old controlled keys
      const preservedQuery = Object.keys(this.$route.query).reduce((acc, key) => {
        if (!controlledKeys.includes(key)) {
          acc[key] = this.$route.query[key]
        }
        return acc
      }, {})

      // Build new controlled search query
      const selectedItem = this.LocalSearchItems.reduce((acc, it) => {
        if (it.selectedOption && it.searchQuery) {
          acc[it.selectedOption.value] = it.searchQuery
        }
        return acc
      }, {})

      // Merge preserved query + controlled filters
      const finalQuery = { ...preservedQuery, ...selectedItem }

      // Update URL only if changed
      const isSameQuery = JSON.stringify(this.$route.query) === JSON.stringify(finalQuery)
      if (!isSameQuery) {
        this.$router.replace({
          path: this.$route.path,
          query: finalQuery,
        })
      }
    },
    addNewSearchAndSelectedItem() {
      this.LocalSearchItems.push({
        searchQuery: '',
        selectedOption: null,
      })
    },
    removeSearchAndSelectedItem(index) {
      // Remove the item at the specified index
      this.LocalSearchItems.splice(index, 1)

      this.handleSearchItems()
    },
  },
}
</script>

<style scoped lang="scss">
.sas {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.sas-row {
  display: flex;
  align-items: stretch;
}

.sas-pill {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  border-radius: 999px;
  background: radial-gradient(circle at top left, #eef2ff 0, #f9fafb 45%, #ecfeff 100%);
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 10px rgba(148, 163, 184, 0.25);
  min-width: 0;
}

.sas-pill-main {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  gap: 0.35rem;
  min-width: 0;
}

.sas-pill-prefix {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: 0.45rem;
  margin-right: 0.35rem;
  border-right: 1px solid #e5e7eb;
}

.sas-pill-where {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #4f46e5;
}

.sas-pill-select {
  flex: 0 0 190px;
  min-width: 0;
}

.sas-pill-input {
  flex: 1 1 auto;
  min-width: 90px;
}

.sas-pill-separator {
  font-size: 0.72rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
}

.sas-input {
  font-size: 0.82rem;
}

.sas-select ::v-deep .vs__dropdown-toggle {
  min-height: 32px;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 0.82rem;
}

.sas-select ::v-deep .vs__selected {
  font-size: 0.82rem;
  font-weight: 900;
}

.sas-pill-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.sas-icon-btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  border: 1px solid transparent;
  background: #f8fafc;
  color: #64748b;
  padding: 0;
  cursor: pointer;
  transition: background 0.1s, color 0.1s, border-color 0.1s;
}

.sas-icon-btn--add {
  border-color: #22c55e;
  color: #16a34a;
  background: #ecfdf3;
}

.sas-icon-btn--add:hover {
  background: #dcfce7;
}

.sas-icon-btn--remove {
  border-color: #f97316;
  color: #ea580c;
  background: #fff7ed;
}

.sas-icon-btn--remove:hover {
  background: #ffedd5;
}

.sas-icon-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.sas-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.2rem;
}

.sas-chips-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  margin-right: 0.15rem;
}

.sas-chip {
  display: inline-flex;
  align-items: baseline;
  gap: 0.15rem;
  padding: 0.1rem 0.55rem;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #e5e7eb;
  font-size: 0.72rem;
  color: #4338ca;
}

.sas-chip-col {
  font-weight: 600;
}

.sas-chip-sep {
  opacity: 0.6;
}

.sas-chip-val {
  color: #1e293b;
}

/* Mobile: stack into a card layout so nothing overflows */
@media (max-width: 767.98px) {
  .sas {
    gap: 0.6rem;
  }

  .sas-row {
    align-items: stretch;
    min-width: 0;
  }

  .sas-pill {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    padding: 0.5rem 0.6rem;
    border-radius: 0.65rem;
    min-width: 0;
    width: 100%;
    box-sizing: border-box;
  }

  .sas-pill-main {
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 0;
  }

  /* Mobile reorder (no new classes): input block first, select block second */
  .sas-pill-separator {
    order: 1;
  }

  .sas-pill-input {
    order: 2;
  }

  .sas-pill-prefix {
    order: 3;
  }

  .sas-pill-select {
    order: 4;
  }

  .sas-pill-prefix {
    margin-right: 0;
    padding-right: 0;
    padding-bottom: 0.35rem;
    margin-bottom: 0.25rem;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }

  .sas-pill-select {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .sas-pill-separator {
    font-size: 0.68rem;
    padding: 0.1rem 0;
  }

  .sas-pill-input {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .sas-input {
    width: 100%;
    box-sizing: border-box;
  }

  .sas-pill-actions {
    width: 100%;
    justify-content: flex-end;
    padding-top: 0.2rem;
    border-top: 1px solid rgba(229, 231, 235, 0.8);
  }

  .sas-icon-btn {
    width: 32px;
    height: 32px;
  }

  .sas-chips {
    margin-top: 0.35rem;
    gap: 0.35rem;
  }

  .sas-chips-label {
    width: 100%;
    font-size: 0.68rem;
    margin-bottom: 0.15rem;
  }

  .sas-chip {
    font-size: 0.68rem;
    padding: 0.15rem 0.5rem;
  }
}

@media (max-width: 575.98px) {
  .sas-pill {
    padding: 0.45rem 0.5rem;
  }

  .sas-select ::v-deep .vs__dropdown-toggle {
    min-height: 36px;
    font-size: 0.8rem;
  }

  .sas-input {
    font-size: 0.8rem;
  }
}
</style>
